<template>
	<div
		:ref="setup._map"
		class="map-holder"
		:style="{ backgroundImage: `url(${setup.backgroundUrl})`, backgroundSize: isCover ? 'cover' : ' contain' }"
		@click="setup.redirectToGoogleMap()">
		<div class="map-holder__overlay">Cliquez pour agrandir la carte</div>
	</div>
</template>

<script setup lang="ts">
import SharedGoogleMapSetupService from '@/setup/shared/SharedGoogleMapSetupService';
const props = defineProps(SharedGoogleMapSetupService.props);
const setup = new SharedGoogleMapSetupService(props);
</script>

<style scoped lang="less">
@import '@/styles/mixins.less';

.map-holder {
  position: relative;
	min-height: 3rem;
	background-position: center;
	background-repeat: no-repeat;
	cursor: pointer;

  &__overlay {
    .flex-align();
    transition: opacity 0.3s;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(var(--rgb-grey-darker), 0.6);
    color: white;
    font-size: 1.25rem;
    font-weight: 600;
    line-height: 1.1;
    padding: 1rem;
    text-align: center;
    opacity: 0;

    &:hover {
      opacity: 1;
    }
  }
}
</style>
